/* eslint-disable react/prop-types */
import React from 'react';
import Modal from 'react-modal';
import FontAwesome from 'react-fontawesome';
import { ClipLoader } from 'react-spinners';
import NoteTemplatesList from "../NoteTemplatesList";
import NoteTemplateRenderer from "../NoteTemplateRenderer";
import NoteTemplatesFilter from "../NoteTemplatesFilter";
import { _ab_color } from "../../style";
import { _LeftSection, _List, _ListWrapper, _Loading, _ManageWrapper, _ModalContainer, _RendererWrapper } from "./styles";
var styles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    transform: 'translate(-50%, -50%)',
    border: 'none',
    background: 'white',
    borderRadius: '7px',
    padding: '0px',
    boxShadow: '0px 5px 6px 0px rgba(0, 0, 0, 0.05)',
    width: '80%',
    height: '80%'
  },
  overlay: {
    zIndex: 2000,
    backgroundColor: 'rgba(24, 39, 56, 0.85)'
  }
};
var NoteTemplatesModal = function NoteTemplatesModal(_ref) {
  var canCreateBulkNote = _ref.canCreateBulkNote,
    isMarkdownRendererEnabled = _ref.isMarkdownRendererEnabled,
    filteredNoteTemplates = _ref.filteredNoteTemplates,
    isNoteTemplatesLoaded = _ref.isNoteTemplatesLoaded,
    isPrivateTab = _ref.isPrivateTab,
    onRenderNoteTemplate = _ref.onRenderNoteTemplate,
    onRequestClose = _ref.onRequestClose,
    onSearchValueChange = _ref.onSearchValueChange,
    onSelectTemplate = _ref.onSelectTemplate,
    permissions = _ref.permissions,
    returnRenderedTemplate = _ref.returnRenderedTemplate,
    searchValue = _ref.searchValue,
    selectAndReturnTemplate = _ref.selectAndReturnTemplate,
    selectedTemplate = _ref.selectedTemplate,
    trackEvent = _ref.trackEvent;
  return /*#__PURE__*/React.createElement(Modal, {
    ariaHideApp: false,
    isOpen: true,
    onRequestClose: onRequestClose,
    style: styles,
    aria: {
      label: 'Note templates'
    }
  }, /*#__PURE__*/React.createElement(_ModalContainer, null, /*#__PURE__*/React.createElement(_LeftSection, null, permissions.edit_note_template && /*#__PURE__*/React.createElement(_ManageWrapper, null, /*#__PURE__*/React.createElement("a", {
    href: "/notes/templates"
  }, /*#__PURE__*/React.createElement(FontAwesome, {
    name: "clipboard"
  }), "Manage Templates")), /*#__PURE__*/React.createElement(NoteTemplatesFilter, {
    searchValue: searchValue,
    onSearchValueChange: onSearchValueChange,
    onlyShowAdminType: permissions.filter_note_template
  }), /*#__PURE__*/React.createElement(_ListWrapper, null, /*#__PURE__*/React.createElement(_List, null, isNoteTemplatesLoaded ? /*#__PURE__*/React.createElement(NoteTemplatesList, {
    clickable: true,
    noteTemplates: filteredNoteTemplates,
    onSelectTemplate: onSelectTemplate,
    onChooseTemplate: selectAndReturnTemplate,
    selectedTemplate: selectedTemplate
  }) : /*#__PURE__*/React.createElement(_Loading, null, /*#__PURE__*/React.createElement(ClipLoader, {
    color: _ab_color.blue,
    size: 30
  }))))), /*#__PURE__*/React.createElement(_RendererWrapper, null, /*#__PURE__*/React.createElement(NoteTemplateRenderer, {
    canCreateBulkNote: canCreateBulkNote,
    isMarkdownRendererEnabled: isMarkdownRendererEnabled,
    isPrivateTab: isPrivateTab,
    onChooseTemplate: returnRenderedTemplate,
    onRenderNoteTemplate: onRenderNoteTemplate,
    onRequestClose: onRequestClose,
    template: selectedTemplate,
    trackEvent: trackEvent
  }))));
};
export default NoteTemplatesModal;